import * as React from 'react';
import { ElementEnum } from '@bumble/proto/hotpanel';

import { PageHeader } from 'components/badoo/page';
import { useHotpanelClickHandler } from 'lib/hotpanel/hooks/use-hotpanel-click-handler';

export const LandingHeaderContainer: React.FC = () => {
    return (
        <PageHeader
            onSignInClick={useHotpanelClickHandler(
                ElementEnum.ELEMENT_SIGN_IN,
                ElementEnum.ELEMENT_HEADER
            )}
            onSignUpClick={useHotpanelClickHandler(
                ElementEnum.ELEMENT_SIGN_UP,
                ElementEnum.ELEMENT_HEADER
            )}
        />
    );
};
